import React, { useState } from 'react';
import { XIcon, DownloadIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { brochurePages } from '../data/brochurePages';
import { downloadBrochurePdf } from '../utils/brochurePdf';
type BrochureModalProps = {
  onClose: () => void;
};
export function BrochureModal({
  onClose
}: BrochureModalProps) {
  const [activePage, setActivePage] = useState(0);
  const page = brochurePages[activePage];
  const goPrev = () => setActivePage(prev => prev === 0 ? brochurePages.length - 1 : prev - 1);
  const goNext = () => setActivePage(prev => prev === brochurePages.length - 1 ? 0 : prev + 1);
  return <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label="Viral Shantivan brochure" onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-10" data-mp="3cc4smnx2ixgx">
      <div className="bg-white rounded-2xl w-full max-w-5xl max-h-[92vh] flex flex-col overflow-hidden shadow-2xl" data-id="element-11" data-mp="wh2vnqwv57tu">
        {/* Header */}
        <div className="flex items-start justify-between gap-4 px-6 py-4 border-b border-gray-100" data-id="element-12" data-mp="3e5v31g8mv0w2">
          <div data-id="element-13" data-mp="3968rdb8gdspd">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-14" data-mp="395pgufl4u6ld">
              Viral Shantivan — Project Brochure
            </h2>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-15" data-mp="346w10gidi3i1">
              {brochurePages.length} pages · Swastik Infra Developer
            </p>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0" aria-label="Close brochure" data-id="element-16" data-mp="2uh2s5n9m82hh">
            <XIcon className="h-5 w-5 text-gray-600" data-id="element-17" data-mp="2lh69q3dtjzuv" />
          </button>
        </div>

        {/* Page viewer */}
        <div className="relative bg-gray-900 flex-1 min-h-0 flex items-center justify-center" data-id="element-18" data-mp="2gi31ka2jldio">
          <img src={page.image} alt={`${page.label} — ${page.description}`} className="max-h-[60vh] w-auto max-w-full object-contain" data-id="element-19" data-mp="2bi8eyipsva3f" />

          <button onClick={goPrev} className="absolute left-3 top-1/2 -translate-y-1/2 p-2.5 bg-white/20 hover:bg-white/40 text-white rounded-full transition-colors" aria-label="Previous page" data-id="element-20" data-mp="26txtgo5nl4c1">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-21" data-mp="1wwt46fgigsr0" />
          </button>
          <button onClick={goNext} className="absolute right-3 top-1/2 -translate-y-1/2 p-2.5 bg-white/20 hover:bg-white/40 text-white rounded-full transition-colors" aria-label="Next page" data-id="element-22" data-mp="2kl40d5b9i48y">
            <ChevronRightIcon className="h-5 w-5" data-id="element-23" data-mp="2bssiw8y4lr54" />
          </button>

          <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full" data-id="element-24" data-mp="2fu4504hsju8k">
            Page {activePage + 1} of {brochurePages.length} · {page.label}
          </div>
        </div>

        {/* Thumbnails */}
        <div className="flex gap-2 px-6 py-3 bg-gray-50 border-t border-gray-100 overflow-x-auto" data-id="element-25" data-mp="38d1ckximiyal">
          {brochurePages.map((thumb, idx) => <button key={thumb.id} onClick={() => setActivePage(idx)} className={`flex-shrink-0 w-24 h-16 rounded-lg overflow-hidden border-2 transition-all ${activePage === idx ? 'border-blue-800 opacity-100' : 'border-transparent opacity-60 hover:opacity-90'}`} aria-label={`Go to page ${idx + 1}: ${thumb.label}`} data-id="element-26" data-mp="rw3dcr5us4nx" data-mpi={idx}>
              <img src={thumb.image} alt={thumb.label} className="w-full h-full object-cover" data-id="element-27" data-mp="nvjftmhdaz19" />
            </button>)}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 flex flex-col sm:flex-row gap-3" data-id="element-28" data-mp="1z9wz0e16eqay">
          <button onClick={downloadBrochurePdf} className="flex-1 inline-flex items-center justify-center gap-2 py-3 bg-blue-800 hover:bg-blue-900 text-white rounded-lg font-medium transition-colors text-sm" data-id="element-29" data-mp="1uc4w6oyztjrz">
            <DownloadIcon className="h-4 w-4" data-id="element-30" data-mp="8tuqaotis2e5" />
            Download Complete Brochure (PDF)
          </button>
          <button onClick={onClose} className="sm:flex-none sm:px-6 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg font-medium transition-colors text-sm" data-id="element-31" data-mp="cxalrhturwp9">
            Close
          </button>
        </div>
      </div>
    </div>;
}